import dayjs from 'dayjs';
import {DEFAULT_DATE_PICKER_VALUE_FORMAT} from '../components/shared/nxDatePicker/NxDatePicker';

export const formatCountdownSeconds = (seconds: number): string =>
  dayjs.duration(seconds, 'seconds').format('mm:ss');

export const DEFAULT_DATE_TIME_FROM = dayjs().subtract(30, 'days').format(DEFAULT_DATE_PICKER_VALUE_FORMAT);
export const DEFAULT_DATE_TIME_TO = dayjs().format(DEFAULT_DATE_PICKER_VALUE_FORMAT)

